import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { AppClientContext } from 'src/app-client/_appCommon/base/AppClientContext';
import { SetupDataService } from 'src/app-client/_dataservices/SetupDataService';
import { CRUDFormControllerBase } from 'src/app-client/_appCommon/base/CRUDFormControllerBase';
import { ICreateBlankCommandSetup } from 'src/app-client/_appCommon/base/AppInterfaceAndBaseClasses';
import { MatStepper } from '@angular/material/stepper';
import { BroadcastManager } from 'src/app-client/_appCommon/base/BroadcastManager';
import { AppEventNames } from 'src/app-client/_appCommon/base/Constants';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-client-crud-setup',
  templateUrl: './crud-setup.component.html',
  styleUrls: ['./crud-setup.component.css'],
  providers: [SetupDataService]
})
export class CrudSetupComponent extends CRUDFormControllerBase<SetupDataService> implements AfterViewInit, AfterViewChecked
{
  @Input() stageNumber: number = 0;
  @Input() isPartialSave: boolean;
  @Input() isCaseFileCompleted: boolean;
  @Input() requiredInitializeStepper : boolean = false;
  @ViewChild('stepper', { static: false }) stepper: MatStepper;
  public isDentalMonitoringSmartSTLCreated: boolean = false;

  private unsubscribe: Subject<void> = new Subject();

  public isSTLFormValid: boolean = false;
  public newPrescriptionOption: number = 1;
  public newPrescriptionOptionSelected: boolean = false;

  constructor(
    activatedRoute: ActivatedRoute,
    setupDataService: SetupDataService,
    private cdr:ChangeDetectorRef,
  )
  {
    super(activatedRoute, setupDataService);
  }

  ngOnInit(): void
  {

    BroadcastManager.Instance.on(AppEventNames.onSTLValidity)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(([data]: any) =>
      {
        this.isSTLFormValid = data[0];
      });

      BroadcastManager.Instance.on(AppEventNames.onDentalMonitoringSmartSTLCreated)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(([data]: any) =>
      {
        this.isDentalMonitoringSmartSTLCreated = data[0];
      });

      BroadcastManager.Instance.on('on-intialize-stepper-to-complete').pipe(takeUntil(this.unsubscribe))
      .subscribe(([data]: any) =>
      {
        if(data[0] == true)
          {
            if(this.stepper.steps.length > 1)
            {
              this.goToPrescription();
              BroadcastManager.Instance.broadcast(AppEventNames.onNotAFirstStageCreated, null);
            }
           
          }
      });

  }

  ngAfterViewInit(): void {
    if(this.isPartialSave || !this.isCaseFileCompleted)
    {
      this.newPrescriptionOptionSelected = true;
      this.cdr.detectChanges();
      this.goToPrescription();
      BroadcastManager.Instance.broadcast(AppEventNames.onNotAFirstStageCreated, null);
    }
    
    if (AppClientContext.Instance.setup.prevPrescription == true) 
    {
      this.newPrescriptionOption = 2;
    }
    else {
      this.newPrescriptionOption = 1;
    }

  }


  ngAfterViewChecked()
  {
  }

  ngOnDestroy(): void
  {
    this.stepper.reset();
  }

  private goForward(): void
  {
    this.stepper.next();
  }

  goToPrescription(): void {

    this.stepper.linear = false;
    if(AppClientContext.Instance.setup.currentStep < 4)
    {
      this.stepper.selectedIndex = 1;
    }
    else
    {
      this.stepper.selectedIndex = 2;
    }
    setTimeout(() => {
       this.stepper.linear = true;
    });
}

  public createNewBlankSetup(): void
  {
    if (AppClientContext.Instance.setup?.id)
    {
      this.updateSetupInfo()
      this.goForward();
      return;
    }

    let blankSetupCommand: ICreateBlankCommandSetup =
    {
      customerId: AppClientContext.Instance.customerId,
      prevPrescription: this.newPrescriptionOption == 2 ? true :false,
      caseId: AppClientContext.Instance.case.id
    };

    this.dataService.createBlankSetup(blankSetupCommand)
      .subscribe((response: any) =>
      {
        AppClientContext.Instance.initializeSetup(response);
        BroadcastManager.Instance.broadcast("on-create-new-case-stage", AppClientContext.Instance.setup.id);
        let body = 
        {
          id: AppClientContext.Instance.setup?.id,
          currentStep: 2
        };
        this.updateSetupCurrentStep(body);
        this.goForward();

        BroadcastManager.Instance.broadcast(AppEventNames.onNotAFirstStageCreated, null);
        
      }, fail =>
      {
        this.setWarningAlert(fail.errorDetail.error.message);
      });
      this.newPrescriptionOptionSelected = true;
  }

  public updateSetupCurrentStepPrescription()
  {
    let body = 
    {
      id: AppClientContext.Instance.setup?.id,
      currentStep: 4
    };
    this.updateSetupCurrentStep(body);
  }

  private updateSetupCurrentStep(body: any)
  {

    this.dataService.updateSetupCurrentStep(body)
    .subscribe(()=>
    {
      BroadcastManager.Instance.broadcast(AppEventNames.onNotAFirstStageCreated, null);
    });
  }

  public updateSetupInfo()
  {
    let body = 
    {
      id: AppClientContext.Instance.setup.id,
      prescriptionId: AppClientContext.Instance.setup.prescriptionId,
      caseFileId: AppClientContext.Instance.setup.caseFileId,
      prevPrescription: this.newPrescriptionOption == 2 ? true :false
    }
    this.dataService.updateSetupById(body)
    .subscribe((res)=>
    {
      AppClientContext.Instance.initializeSetup(res);
    });
  }
}
